<span *ngFor="let item of list; let last = last">
    <span *ngIf="item">
        <span>{{item}}</span>
        <span *ngIf="!last">&nbsp; | &nbsp;</span>
    </span>
</span>